var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "receipt-info-container" },
    [
      _vm.displaySubtotal
        ? _c("info-item", {
            attrs: { name: "Subtotal", value: _vm.displaySubtotal }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.displayTotalDiscount
        ? _c("info-item", {
            attrs: { name: "Discount", value: _vm.displayTotalDiscount }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.displayServiceCharge
        ? _c("info-item", {
            attrs: { name: "Service Charge", value: _vm.displayServiceCharge }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.displayTip
        ? _c("info-item", { attrs: { name: "Tip", value: _vm.displayTip } })
        : _vm._e(),
      _vm._v(" "),
      _vm.displayTax
        ? _c("info-item", { attrs: { name: "Tax", value: _vm.displayTax } })
        : _vm._e(),
      _vm._v(" "),
      _vm.displayTotal
        ? _c("info-item", {
            attrs: { name: "Total", value: _vm.displayTotal, hideBorder: true }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14c16da6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14c16da6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkout/ReceiptInfo.vue
// module id = null
// module chunks = 